export interface Article {
  slug: string;
  title: string;
  summary: string;
  content: string;
  category: string;
  categoryName: string;
  date: string;
  coverImage: string;
  tags: string[];
  views: number;
  author: string;
}

export const articles: Article[] = [
  {
    slug: "daily-contest-2024-winter",
    title: "2024冬季每日大赛总决赛精彩回顾：谁是最强吃瓜王",
    summary: "51吃瓜网每日大赛冬季总决赛落下帷幕，各路吃瓜高手齐聚一堂比拼八卦功力，现场高潮迭起瓜料不断。",
    content: `<p>2024年冬季，51吃瓜网每日大赛迎来了年度最受瞩目的总决赛。经过数月的激烈角逐，来自全国各地的吃瓜高手齐聚一堂，为观众们带来了一场精彩绝伦的八卦盛宴。</p>
    <p>本次总决赛汇集了本季度最具话题性的八卦新闻，从娱乐圈恋情曝光到网红圈恩怨纠葛，每一条瓜料都经过选手们的深度挖掘和精彩解读。</p>
    <p>比赛分为三个环节：速报环节、深度挖掘环节和即兴评论环节。选手们需要在限定时间内对最新瓜料进行快速反应和深度分析，展现自己作为专业吃瓜人的素养。</p>
    <p>最终，经过评委和观众的双重投票，来自上海的小王凭借对某顶流明星恋情瓜的精彩解读夺得了本届大赛的冠军，赢得了"最强吃瓜王"的称号。</p>
    <p>赛后，冠军小王在接受采访时表示：吃瓜不仅是一种娱乐，更是一门艺术。要学会在纷繁复杂的信息中找出真相，同时保持对当事人的基本尊重。</p>`,
    category: "daily-contest",
    categoryName: "每日大赛",
    date: "2026-07-28",
    coverImage: "https://readdy.ai/api/search-image?query=Entertainment%20gossip%20event%20stage%20with%20colorful%20lights%20and%20audience%2C%20modern%20talk%20show%20atmosphere%2C%20dramatic%20lighting%2C%20warm%20tones%2C%20professional%20photography%2C%20clean%20composition%2C%20dark%20background%20with%20spotlights&width=800&height=450&seq=daily-contest-winter&orientation=landscape",
    tags: ["每日大赛", "总决赛", "吃瓜王", "八卦"],
    views: 128500,
    author: "51吃瓜编辑部",
  },
  {
    slug: "taipei-nana-august-collection",
    title: "台北娜娜八月最新合集：多部热门作品一次看个够",
    summary: "台北娜娜八月合集正式上线，收录本月多部热门视频作品，高清画质带来极致观看体验。",
    content: `<p>台北娜娜八月合集如约而至！本月娜娜为大家带来了多部精彩作品，涵盖不同风格和主题，满足各类粉丝的观看需求。</p>
    <p>本月合集亮点包括娜娜与多位知名创作者的联动作品，创意十足的画面设计和引人入胜的剧情走向让每一部作品都值得反复欣赏。</p>
    <p>据娜娜团队透露，为筹备本月合集，团队耗时近两个月进行拍摄和后期制作，投入了比以往更多的精力和资源，力求为粉丝带来更高质量的视觉体验。</p>
    <p>粉丝们纷纷在评论区表示：娜娜的作品质量越来越高了，每一帧都是艺术品，期待下个月的合集！</p>`,
    category: "taipei-nana",
    categoryName: "台北娜娜",
    date: "2026-08-01",
    coverImage: "https://readdy.ai/api/search-image?query=Taipei%20night%20cityscape%20with%20neon%20lights%20and%20modern%20urban%20atmosphere%2C%20fashionable%20aesthetic%2C%20warm%20evening%20tones%2C%20cinematic%20photography%2C%20soft%20bokeh%20background%2C%20elegant%20composition&width=800&height=450&seq=taipei-nana-august&orientation=landscape",
    tags: ["台北娜娜", "八月合集", "视频", "高清"],
    views: 256800,
    author: "51吃瓜编辑部",
  },
  {
    slug: "mori-show-exclusive-2026",
    title: "莫里秀独家专访：揭秘幕后创作故事与最新动态",
    summary: "51吃瓜莫里秀独家专访，莫里秀团队首次公开分享创作历程和不为人知的幕后故事。",
    content: `<p>近日，51吃瓜网有幸邀请到莫里秀团队进行了一次深度专访。这是莫里秀首次接受媒体专访，团队主创人员与我们分享了他们的创作理念和心路历程。</p>
    <p>莫里秀作为当下最受关注的内容创作者之一，其独特的风格和高质量的作品一直备受粉丝喜爱。在这次专访中，团队透露了他们对于内容创作的执着追求：每一部作品都经过精心策划和反复打磨，力求做到最好。</p>
    <p>团队也分享了创作过程中的一些趣事和挑战。比如有一次为了拍摄一个特定场景，团队在户外连续工作了16个小时，最终呈现的效果让所有人都感到值得。</p>
    <p>对于未来的规划，莫里秀团队表示将继续坚持高质量的创作路线，同时也在探索更多元化的内容形式，敬请粉丝期待。</p>`,
    category: "mori-show",
    categoryName: "莫里秀",
    date: "2026-07-25",
    coverImage: "https://readdy.ai/api/search-image?query=Professional%20studio%20interview%20setup%20with%20warm%20lighting%2C%20modern%20creative%20workspace%2C%20cinematic%20atmosphere%2C%20artistic%20vibe%2C%20soft%20shadows%2C%20elegant%20composition%2C%20dark%20moody%20background&width=800&height=450&seq=mori-show-exclusive&orientation=landscape",
    tags: ["莫里秀", "独家专访", "幕后故事", "创作"],
    views: 189200,
    author: "51吃瓜编辑部",
  },
  {
    slug: "doll-sister-summer-special",
    title: "玩偶姐姐夏日特辑：清凉一夏的视觉盛宴",
    summary: "玩偶姐姐夏日特别企划正式发布，清新风格搭配精良制作，带来不一样的视觉享受。",
    content: `<p>炎炎夏日，玩偶姐姐为粉丝们准备了特别的夏日企划。这组夏日特辑以清新自然为主题，展现了与以往不同的风格面貌。</p>
    <p>本次夏日特辑取景于海边和森林等多个自然场景，玩偶姐姐以轻松自然的姿态融入其中，为观众带来了一场清凉的视觉盛宴。</p>
    <p>制作团队表示，此次特辑的拍摄历时一周，跨越多地取景，后期制作更是精益求精。每一个镜头都经过精心设计，力求呈现出最完美的画面效果。</p>
    <p>粉丝反响热烈，该特辑上线后迅速登上热门榜单。许多粉丝留言称赞这次的作品风格清新，给人带来了夏日的清凉感受。</p>`,
    category: "doll-sister",
    categoryName: "玩偶姐姐",
    date: "2026-07-30",
    coverImage: "https://readdy.ai/api/search-image?query=Summer%20beach%20scene%20with%20soft%20natural%20lighting%2C%20gentle%20ocean%20waves%2C%20warm%20golden%20hour%20tones%2C%20fashion%20editorial%20style%2C%20clean%20aesthetic%2C%20dreamy%20atmosphere%2C%20artistic%20composition&width=800&height=450&seq=doll-sister-summer&orientation=landscape",
    tags: ["玩偶姐姐", "夏日特辑", "视觉盛宴", "新风格"],
    views: 312400,
    author: "51吃瓜编辑部",
  },
  {
    slug: "exposure-celebrity-romance",
    title: "独家爆料：某顶流艺人恋情曝光，圈内震动",
    summary: "娱乐圈再爆重磅八卦，某顶流艺人被拍到与神秘对象深夜同框，引发全网热议。",
    content: `<p>近日，有网友拍到某顶流艺人与一位神秘对象在某高档小区深夜同框的画面，照片一经曝光立即引发全网热议。</p>
    <p>据知情人士透露，两人已经交往数月，但因为双方都处于事业上升期，一直对外保持低调。这次被拍到后，不少粉丝表示支持和祝福。</p>
    <p>该艺人的工作室目前尚未对此事做出官方回应。但圈内人士表示，艺人也是普通人，有追求幸福的权利，希望大家给予理解和空间。</p>
    <p>此事也引发了关于艺人隐私权的讨论。有评论认为，公众人物固然需要接受大众关注，但私人生活仍应受到基本尊重。</p>`,
    category: "exposure",
    categoryName: "黑料吃瓜",
    date: "2026-07-29",
    coverImage: "https://readdy.ai/api/search-image?query=Paparazzi%20style%20night%20city%20scene%20with%20blurred%20figures%2C%20mysterious%20atmosphere%2C%20street%20lights%20glowing%2C%20dramatic%20shadows%2C%20cinematic%20noir%20style%2C%20warm%20street%20lamp%20tones%2C%20intriguing%20composition&width=800&height=450&seq=celebrity-romance&orientation=landscape",
    tags: ["黑料吃瓜", "恋情曝光", "顶流艺人", "八卦"],
    views: 456700,
    author: "51吃瓜爆料组",
  },
  {
    slug: "collection-best-of-july",
    title: "七月精选合集：本月最火视频TOP10大盘点",
    summary: "51吃瓜七月视频合集精选TOP10，从每日大赛精彩片段到玩偶姐姐热门作品，一网打尽。",
    content: `<p>七月的51吃瓜平台热闹非凡，各栏目都产出了大量优质内容。经过数据统计和用户投票，我们评选出了本月最受欢迎的10部视频作品。</p>
    <p>其中，玩偶姐姐的夏日特辑以超高点击量和好评率夺得本月榜首。紧随其后的是莫里秀的创意短片和台北娜娜的最新作品。</p>
    <p>值得一提的是，每日大赛板块本月也贡献了多个爆款内容，其中冬季总决赛的精彩片段获得了大量转发和讨论。</p>
    <p>完整榜单和视频链接已经整理完毕，点击下方链接即可观看本月所有热门内容，不错过任何一个精彩瞬间。</p>`,
    category: "collection",
    categoryName: "视频合集",
    date: "2026-08-01",
    coverImage: "https://readdy.ai/api/search-image?query=Video%20collection%20grid%20display%20with%20colorful%20thumbnails%2C%20modern%20digital%20media%20aesthetic%2C%20warm%20ambient%20lighting%2C%20clean%20layout%2C%20professional%20streaming%20platform%20style%2C%20dark%20background%20with%20vibrant%20accents&width=800&height=450&seq=best-of-july&orientation=landscape",
    tags: ["视频合集", "TOP10", "七月精选", "盘点"],
    views: 98700,
    author: "51吃瓜编辑部",
  },
  {
    slug: "daily-contest-spring-preview",
    title: "春季每日大赛预告：全新赛制与神秘评委曝光",
    summary: "51吃瓜网每日大赛春季赛季即将开启，全新赛制升级与特邀评委阵容首次曝光。",
    content: `<p>随着冬季总决赛的圆满结束，51吃瓜网每日大赛春季赛季的筹备工作已经全面启动。据悉，春季赛季将带来多项重磅升级。</p>
    <p>首先是赛制方面的变化。新赛季将引入团队对抗模式，选手们将分成不同战队进行PK，增加了比赛的观赏性和策略性。</p>
    <p>其次是评委阵容的升级。据内部消息，新赛季将邀请多位圈内知名人士担任特邀评委，包括知名娱乐评论人、资深媒体人和前八卦周刊主编等。</p>
    <p>春季赛季报名通道即将开启，欢迎各位吃瓜达人踊跃报名，争夺新一季的吃瓜之王称号！</p>`,
    category: "daily-contest",
    categoryName: "每日大赛",
    date: "2026-07-22",
    coverImage: "https://readdy.ai/api/search-image?query=Spring%20themed%20event%20stage%20with%20cherry%20blossoms%20and%20warm%20lighting%2C%20modern%20competition%20arena%20atmosphere%2C%20pink%20and%20gold%20tones%2C%20professional%20event%20photography%2C%20elegant%20composition%2C%20soft%20atmospheric%20background&width=800&height=450&seq=spring-preview&orientation=landscape",
    tags: ["每日大赛", "春季赛季", "新赛制", "评委阵容"],
    views: 76500,
    author: "51吃瓜编辑部",
  },
  {
    slug: "taipei-nana-fan-meeting",
    title: "台北娜娜粉丝见面会盛况：千人齐聚共度美好时光",
    summary: "台北娜娜首次线下粉丝见面会在台北成功举办，超千名粉丝到场支持，现场气氛热烈。",
    content: `<p>台北娜娜首次线下粉丝见面会在台北国际会议中心圆满落幕。据悉，当天有超过一千名粉丝从各地赶来，现场座无虚席。</p>
    <p>活动中，娜娜不仅与粉丝进行了亲密互动，还首次公开演唱了自己创作的主题曲，赢得了全场热烈的掌声和欢呼。</p>
    <p>见面会还设置了多个互动环节，包括问答环节、抽奖环节和签名合影环节。幸运粉丝还有机会与娜娜进行一对一的交流。</p>
    <p>娜娜在活动结束时感动落泪，感谢粉丝一直以来的支持和陪伴。她表示会继续努力创作更好的内容，不辜负大家的期待。</p>`,
    category: "taipei-nana",
    categoryName: "台北娜娜",
    date: "2026-07-20",
    coverImage: "https://readdy.ai/api/search-image?query=Large%20fan%20meeting%20event%20with%20cheering%20crowd%20and%20stage%20lights%2C%20concert%20atmosphere%2C%20warm%20spotlight%20illumination%2C%20emotional%20moment%2C%20professional%20event%20photography%2C%20dark%20venue%20with%20colorful%20stage%20lighting&width=800&height=450&seq=nana-fan-meeting&orientation=landscape",
    tags: ["台北娜娜", "粉丝见面会", "线下活动", "台北"],
    views: 213600,
    author: "51吃瓜编辑部",
  },
  {
    slug: "mori-show-new-series",
    title: "莫里秀全新系列预告：颠覆性创意引发期待",
    summary: "莫里秀官方发布全新系列预告片，前所未有的创意概念引发粉丝热烈讨论和期待。",
    content: `<p>莫里秀官方社交账号于昨日发布了一支时长30秒的预告片，宣布将推出全新系列内容。这支预告片以极具视觉冲击力的画面和神秘的音乐吸引了大量关注。</p>
    <p>从预告片中可以看出，新系列在视觉风格上有了明显突破。采用了全新的拍摄手法和后期处理技术，呈现出电影级别的画面质感。</p>
    <p>粉丝们对这支预告片进行了热烈讨论，各种猜测和解读层出不穷。有人猜测新系列将采用叙事性更强的剧情模式，也有人认为可能会融入更多的特效元素。</p>
    <p>莫里秀团队随后在评论中回复称，新系列将是他们有史以来最大胆的尝试，希望给观众带来前所未有的观看体验。正式发布时间定于八月中旬。</p>`,
    category: "mori-show",
    categoryName: "莫里秀",
    date: "2026-07-18",
    coverImage: "https://readdy.ai/api/search-image?query=Futuristic%20creative%20studio%20with%20dramatic%20neon%20lighting%2C%20mysterious%20atmosphere%2C%20cinematic%20teaser%20aesthetic%2C%20dark%20background%20with%20vibrant%20color%20accents%2C%20professional%20film%20production%20style%2C%20artistic%20composition&width=800&height=450&seq=mori-new-series&orientation=landscape",
    tags: ["莫里秀", "新系列", "预告片", "创意"],
    views: 145300,
    author: "51吃瓜编辑部",
  },
  {
    slug: "doll-sister-behind-scenes",
    title: "玩偶姐姐拍摄花絮曝光：台前幕后都这么美",
    summary: "玩偶姐姐最新拍摄现场花絮流出，专业认真的一面让粉丝直呼更加圈粉。",
    content: `<p>近日，玩偶姐姐团队在社交平台分享了一组拍摄现场的花絮照片和短视频，展现了玩偶姐姐在镜头之外的真实状态。</p>
    <p>花絮中可以看到，玩偶姐姐在拍摄间隙认真与导演沟通每个镜头细节，对作品质量的要求非常高。即使是一个简单的走位，她也会反复练习直到满意为止。</p>
    <p>团队成员透露，玩偶姐姐在拍摄时非常敬业，常常是最后一个离开片场的人。即使天气炎热或条件艰苦，她也从不抱怨，始终保持着专业的态度。</p>
    <p>这些花絮让粉丝们看到了玩偶姐姐的另一面，纷纷留言表示：认真的女人最美，更加喜欢她了！也有粉丝表示期待看到更多这样的幕后内容。</p>`,
    category: "doll-sister",
    categoryName: "玩偶姐姐",
    date: "2026-07-15",
    coverImage: "https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20film%20production%20set%20with%20professional%20crew%20and%20equipment%2C%20warm%20work%20lighting%2C%20creative%20atmosphere%2C%20documentary%20style%20photography%2C%20natural%20candid%20moments%2C%20soft%20ambient%20tones&width=800&height=450&seq=doll-behind-scenes&orientation=landscape",
    tags: ["玩偶姐姐", "拍摄花絮", "幕后", "敬业"],
    views: 178900,
    author: "51吃瓜编辑部",
  },
  {
    slug: "exposure-industry-secrets",
    title: "圈内人爆料：娱乐圈不为人知的潜规则大揭秘",
    summary: "多位圈内人士匿名爆料，揭秘娱乐圈中鲜为人知的潜规则和行业内幕。",
    content: `<p>本期黑料吃瓜特别策划，我们采访了多位在娱乐圈工作多年的匿名人士，为大家揭秘那些不为人知的行业内幕。</p>
    <p>据一位在经纪公司工作超过十年的资深人士透露，娱乐圈的竞争远比外界想象的更加激烈。表面上的光鲜亮丽背后，是无数不为人知的辛酸和牺牲。</p>
    <p>另一位曾在多个知名剧组工作过的受访者分享了片场的一些潜规则，包括资源分配的不公、新人的生存困境以及行业内存在的各种微妙关系。</p>
    <p>需要说明的是，本文内容均来自受访者个人经历和观点，不代表本平台立场。我们旨在客观呈现信息，让读者了解一个更加真实的娱乐圈。</p>`,
    category: "exposure",
    categoryName: "黑料吃瓜",
    date: "2026-07-12",
    coverImage: "https://readdy.ai/api/search-image?query=Mysterious%20silhouette%20figure%20in%20shadow%20with%20dramatic%20backlighting%2C%20anonymous%20interview%20concept%2C%20dark%20moody%20atmosphere%2C%20film%20noir%20style%2C%20professional%20photography%2C%20warm%20accent%20light%2C%20intriguing%20composition&width=800&height=450&seq=industry-secrets&orientation=landscape",
    tags: ["黑料吃瓜", "娱乐圈", "潜规则", "爆料"],
    views: 389200,
    author: "51吃瓜爆料组",
  },
  {
    slug: "collection-august-preview",
    title: "八月视频合集预告：本月即将上线的重磅内容",
    summary: "51吃瓜八月视频合集预告单曝光，多部重磅作品即将上线，精彩不容错过。",
    content: `<p>八月已至，51吃瓜平台各栏目都准备了丰富的内容盛宴。以下是本月即将上线的一些重磅作品预告。</p>
    <p>首先是台北娜娜的八月合集，据悉本次合集将包含多个全新主题的作品，制作规格较之前有了明显提升。</p>
    <p>玩偶姐姐方面，继夏日特辑获得好评后，团队正在筹备秋季特别企划，预计本月下旬与大家见面。</p>
    <p>莫里秀的全新系列也将在本月中旬正式发布，从目前流出的预告来看，这将是今年最值得期待的内容之一。</p>
    <p>此外，每日大赛的春季赛季也将在本月启动报名。今年的赛制全面升级，奖金池也创下历史新高。</p>`,
    category: "collection",
    categoryName: "视频合集",
    date: "2026-08-02",
    coverImage: "https://readdy.ai/api/search-image?query=Calendar%20themed%20August%20preview%20with%20warm%20summer%20aesthetic%2C%20golden%20light%2C%20modern%20content%20creator%20vibe%2C%20professional%20photography%2C%20clean%20editorial%20style%2C%20soft%20warm%20background%20with%20subtle%20texture&width=800&height=450&seq=august-preview&orientation=landscape",
    tags: ["视频合集", "八月预告", "重磅内容", "预告"],
    views: 65400,
    author: "51吃瓜编辑部",
  },
];